import { getStore } from '../store/Store';
import { getUnseenItemIds } from './getUnseenItemIds';

/** Selector which returns a boolean value indicating the presence of Unseen items */
export function areUnseenItemsPresent(): boolean {
    const { areNewNotificationsPresent } = getStore();

    return getUnseenItemIds().length > 0 || areNewNotificationsPresent;
}
